import { useLocation } from 'react-router-dom';
import Header from 'components/common/Header';
import SubNavigation from 'components/common/SubNavigation';
import { DownloadAssetDataButton } from './DownloadAssetDataButton/DownloadAssetDataButton';

const InventoryManagementHeader = () => {
  const { pathname } = useLocation();

  const createActionButton = () => {
    if (!pathname.includes('setup')) return null;

    return <DownloadAssetDataButton />;
  };

  return (
    <Header
      title="Inventory management"
      subNavigation={
        <SubNavigation
          tabsConfig={[
            {
              id: 1,
              path: '/inventory-management/setup',
              isVisible: true,
              name: 'Setup',
            },
            {
              id: 2,
              path: '/inventory-management/asset-health',
              isVisible: true,
              name: 'Asset health',
            },
            {
              id: 3,
              path: '/inventory-management/asset-list',
              isVisible: true,
              name: 'Asset list',
            },
            {
              id: 4,
              path: '/inventory-management/reference-data',
              isVisible: false,
              name: 'Reference data',
            },
            {
              id: 5,
              path: '/inventory-management/commercial-entities',
              isVisible: false,
              name: 'Commercial entities',
            },
          ]}
        />
      }
      actionButton={createActionButton()}
    />
  );
};

export default InventoryManagementHeader;
